import React, { useState, useEffect } from "react";
import { Table, Space, Button, Row, Col, Modal, Select, Input, Tooltip, Pagination } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { quotationService } from "../../../services";
import { changeDocumentTitle } from "../../../utils/title";
import { checkPermission } from "../../../utils/permissions";

function Quotation() {
  const navigate = useNavigate();

  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(false);
  const editQuotation = (id) => navigate(`/operations/quotation/form/${id}`);
  const [isModalshow, setIsModalShow] = useState();
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [search, setSearch] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Validity",
      dataIndex: "validity_date",
      key: "validity_date",
    },

    {
      title: "Actions",
      key: "Actions",
      render: (text, record) => (
        <Space size="small">
          {checkPermission("EDIT_QUOTATIONS") && (
            <Tooltip title="Edit">
              {/* <Button
              type="primary"
              size="small"
              onClick={() => editQuotation(record.id)}
            > */}
              <EditOutlined onClick={() => editQuotation(record.id)} />
              {/* </Button> */}
            </Tooltip>
          )}
          {checkPermission("VIEW_QUOTATIONS") && (

            <Link to={`/operations/quotation/view/${record.id}`} className="hover:text-primary">
              <Tooltip title="View">
                {/* <Button type="primary" size="small"> */}
                <EyeOutlined />
                {/* </Button> */}
              </Tooltip>
            </Link>
          )}
          {checkPermission("DELETE_QUOTATIONS") && (
            <Tooltip title="Delete">
              {/* <Button type="primary" size="small" > */}
              <DeleteOutlined onClick={() => showModal(record)} />
              {/* </Button> */}
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const showModal = (record) => {
    setSelectedDeleteRecord(record);
    setIsModalShow(true);
  };

  const handleOk = async () => {
    setLoading(true);
    const response = await quotationService.deleteQuotation(
      selectedDeleteRecord.id
    );
    if (response.success) {
      setQuotations((prevData) =>
        prevData.filter((item) => item.id !== selectedDeleteRecord.id)
      );
      initialize();
    } else {
      console.error("Failed to delete the customer.");
    }
    setIsModalShow(false);
    setLoading(false);
  };

  const handleCancel = () => {
    setIsModalShow(false);
  };


  const initialize = async (page = 1, pageSize = pagination.pageSize, search = null) => {
    setLoading(true);
    const { success, data } = await quotationService.fetch(page, pageSize, search);
    if (success) {
      setQuotations(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle("Quotations");
    initialize(pagination.current, pagination.pageSize, search);
  }, [search]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Browse Quotations
        </h1>
        <Input
          placeholder="Search by Name"
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* delete */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px",
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleOk} style={{ width: "30%" }}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this Quotation?
        </p>
      </Modal>

      <Table
        columns={columns}
        loading={loading}
        scroll={{ x: "max-content" }}
        dataSource={quotations}
        rowKey="id"
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        //   showSizeChanger: false,
        // }}
        pagination={false}
        style={{ marginTop: "10px" }}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}

export default Quotation;
